import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { IArbetsorderHandelssortimentPrimaryKey } from "./ArbetsorderHandelssortimentBaseCommand";

export abstract class ArbetsorderProduktBaseCommand extends BasicCommand<ArbetsorderProduktBaseCommand> {
    handelssortimentId: number;
    produktId: number;
    arbetsorderId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "ArbetsorderProdukt";
    get primaryKey(): IArbetsorderProduktPrimaryKey {
        return {
            arbetsorderId: this.arbetsorderId,
            handelssortimentId: this.handelssortimentId,
            produktId: this.produktId
        };
    }
    constructor($type, commandType) {
        super($type, ArbetsorderProduktBaseCommand.$groupKey, commandType);
    }
}

export interface IArbetsorderProduktPrimaryKey extends IArbetsorderHandelssortimentPrimaryKey {
    produktId: number;
}
